import { ApiResponse } from '@interfaces/index';
import { apiUrlConfig } from './configs/apiUrlConfig';
import createApiClient from './configs/httpHandler';

export const thoughtsAndSpeakUpsApiHandler = {
  getThoughtsAndSpeakUps: async (
    payload: Partial<GetThoughtsAndSpeakUpsPayload>,
  ): Promise<ApiResponse<ThoughtsAndSpeakUpsResponseInterface[]>> =>
    createApiClient(apiUrlConfig.EXPRESS_BACKEND_V2).post(
      '/get-user-thoughts-and-speak-ups',
      payload,
    ),
};

export interface GetThoughtsAndSpeakUpsPayload {
  archived: boolean | null;
  type: string | null;
}

export interface ThoughtsAndSpeakUpsResponseInterface {
  id: number;
  type: 'thoughts' | 'speakUps';
  questionId: number | null;
  questionLabel: string | null;
  questionnaire: string | null;
  score: number | null;
  message: string;
  shared: boolean;
  latestResponse: {
    id: number;
    response: string;
    createdAt: string;
  } | null;
  createdAt: string;
  updatedAt: string;
}
